import { ObjectStoreMeta } from "ngx-indexed-db";
import { DagreNodesOnlySettings, TLayerIDs } from "../modules/graph-konva/models/graph-kn.cm-api-models";
export const UI_SETTING_STORAGE = 'ui_settings'
export type TUISettingsCodes = 'contractTableInstance'
export const UISettingsStoreConfig: ObjectStoreMeta = {
    store: UI_SETTING_STORAGE,
    storeConfig: {keyPath: 'ui_item_id', autoIncrement: true},
    storeSchema: [
        {name: 'ui_item_id', keypath: 'ui_item_id', options: {unique: true}},
        {name: 'ui_settings_value', keypath: 'setting_value', options: {unique: false}},
        {name: 'ui_settings_type', keypath: 'setting_value', options: {unique: false}},
    ],
}
export interface IUI_SettingStorage {
  ui_item_id:string,
  settings:IUI_Settings
}
export interface IUI_Settings {
  user_guid:string
  tables?:IUI_SettingsTable[],
  graph?:IUI_SettingsGraph[]
}
export interface IUI_SettingsTable {
  table_code:TUISettingsCodes,
  custom_fields?:string[],
  fields?:string[],
  rows_qty_to_cache?: number,
  sort_default?: string,
  page_rows_qty?: number,
}
export interface IUI_SettingsGraph {
  component_code?:string,
  layout_settings?:IUI_SettingsGraphLayoutSettings[]
}
export interface IUI_SettingsGraphLayoutSettings {
  layerId:TLayerIDs, 
  settings:DagreNodesOnlySettings
}